<template>
  <v-dialog
      v-model="showEmailModal"
      content-class="email-dialog"
      style="max-width: 800px !important; z-index: 1;"
    >
    <v-layout class="email-form-container elevation-5" wrap>
      <v-flex xs12
        v-if="!$vuetify.breakpoint.mdAndUp"
      >
        <img
          src="/img/close.png"
          style="align: right;float: right;"
          @click="showEmailModal = false"
        >
      </v-flex>
      <v-flex v-if="!sent" xs12 md9 pa-3>
        <h2 style="font-size: 20px; padding-bottom: 10px; color:#333;">
            {{ $t('saada_see_lehekylg') }}
        </h2>
        <div style="width: 100%; clear: both;">
          <object-list-info
            v-if="selectedObject && selectedObject._id"
            :object="selectedObject"
            :booking-now="false"
            :emailing="true"
          />
        </div>
        <ul class="contact_form email-form">
          <li>
            <label>{{ $t('saaja_email') }}: *</label>
            <input v-model="receiverEmail" class="contact_input" type="email" name="saaja_email" id="saaja_email" style="color: rgb(128, 128, 128);">
          </li>

          <li>
            <label>{{ $t('teema') }}: *</label>
            <input v-model="subject" class="contact_input" type="text" name="teema" value="Plaza San Rafael 5, Los Boliches, Fuengirola, Málaga, Spain" style="color: rgb(128, 128, 128);">
          </li>

          <li>
            <label>{{ $t('teade') }}:</label>
            <textarea v-model="message" class="contact_input" name="teade" style="color: rgb(128, 128, 128);"></textarea>
          </li>

          <li><hr></li>
          <li>
            <label>{{ $t('saatja_nimi') }}:</label>
            <input v-model="senderName" class="contact_input" type="text" name="saatja_nimi" style="color: rgb(128, 128, 128);">
          </li>

          <li>
            <label>{{ $t('saatja_email') }}: *</label>
            <input v-model="senderEmail" class="contact_input" type="email" name="saatja_email" style="color: rgb(128, 128, 128);">
          </li>
        </ul>
      </v-flex>
      <v-flex v-else xs12 md9 pa-3>
        <h2>{{ $t('teade_on_saadetud') }}</h2>
        <ul class="contact_form email-form">
          <li>
            <label>{{ $t('saaja_email') }}:</label>
            <span>{{ receiverEmail }}</span>
          </li>

          <li>
            <label>{{ $t('teema') }}:</label>
            <span>{{ subject }}</span>
          </li>

          <li>
            <label>{{ $t('teade') }}:</label>
            <span>{{ message }}</span>
          </li>
          <li>
            <label>{{ $t('saatja_nimi') }}:</label>
            <span>{{ senderName }}</span>
          </li>

          <li>
            <label>{{ $t('saatja_email') }}:</label>
            <span>{{ senderEmail }}</span>
          </li>
        </ul>
        <br>
        <a @click="resetAndBack()">{{ $t('saada_veel_üks') }}</a>
        <br><br>
        <input
          style="margin-bottom: 10px; min-width: 155px;"
          type="button"
          :value="$t('sulge')"
          @click="showEmailModal = false"
        >
      </v-flex>
      <v-flex xs12 md3 pa-3>
        <v-layout wrap fill-height>
          <v-flex xs12
            v-if="$vuetify.breakpoint.mdAndUp"
          >
            <img
              src="/img/close.png"
              style="align: right;float: right; position: relative; top: -10px; right: -10px;"
              @click="showEmailModal = false"
            ><br>
            <img src="/img/costa_stamp.png">
          </v-flex>
          <v-flex xs12 v-if="!sent">
            <v-layout align-end fill-height>
              <v-flex xs12>
                <input
                  style="margin-bottom: 10px; min-width: 155px;"
                  type="button"
                  :class="dataValid ? '' : 'disabled-button'"
                  :value="$t('saada')"
                  @click="send($event)"
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-dialog>
</template>

<script>
import api from './../api.js'
import { load } from 'recaptcha-v3'

import ObjectListInfo from './ObjectListInfo'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

const isValidEmail = email => {
  let re = /\S+@\S+\.\S+/
  return re.test(String(email).toLowerCase())
}

export default {
  name: 'EmailForm',

  components: {
    ObjectListInfo
  },

  data () {
    return {
      sent: false,
      senderEmail: null,
      senderName: null,
      receiverEmail: null,
      subject: null,
      message: null
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    dataValid () {
      return isValidEmail(this.senderEmail) &&
        isValidEmail(this.receiverEmail) &&
        this.subject
    }
  },

  watch: {
    showEmailModal (value) {
      if (!value) {
        setTimeout(() => {
          this.resetAndBack()
        }, 1000)
      } else {
        this.subject = this.subject || this.selectedObject.objectName
      }
    }
  },

  methods: {
    send (e) {
      if (this.dataValid) {
        load('6LcXu6MZAAAAAPHnlaHBgqjGHzrkJU_HntrFVW0y').then((recaptcha) => {
          recaptcha.execute(this.send2).then((token) => {
              // console.log(token) // Will print the token
              api.shareByEmail({
                token: token,
                senderEmail: this.senderEmail,
                senderName: this.senderName,
                receiverEmail: this.receiverEmail,
                subject: this.subject,
                message: this.message,
                object: this.selectedObject,
                translations: this.translationsByLang,
                lang: this.lang
              })
              this.sent = true
            })
        })
      }
    },

    send2 () {
      console.log('send2???')
    },

    resetAndBack () {
      // this.senderEmail = null
      // this.senderName = null
      this.receiverEmail = null
      // this.subject = null
      // this.message = null
      this.sent = false
    }
  }
}
</script>

<style>
.email-form-container {
  border: 3px solid white;
  background: #ffcb01;
}
.email-form-object {
  background: white;
  padding: 10px;
  margin: 10px 10px 10px 0;
}

ul.contact_form li {
	list-style-type: none;
	margin-bottom: 5px;
}

ul.contact_form label {
	list-style-type: none;
	margin-bottom: 10px;
	display: inline-block;
	width: 21%;
}

.contact_input {
	width: 78%;
}

.contact_input_half {
	width: 38%;
}

.contact_input_third {
	width: 25.6%;
	display: inline-block;
}

textarea.contact_input {
	height: 150px;
}
textarea.contact_input {
	height: 150px;
}
textarea {
  background-color: white !important;
  border-color: #848484 #c1c1c1 #e1e1e1 !important;
  border-style: solid !important;
}
.email-form {
  margin-bottom: 0px !important;
  clear: both;
}
.email-dialog {
  max-width: 1000px;
}
.disabled-button {
  color: gray !important;
  cursor: not-allowed !important;
}
</style>
